const PUBLIC_URL = process.env.PUBLIC_URL || '';

/** דוגמת עיטורים עדינה (כמו רקע המותג) — בלי לוגו כפול */
const HALACHA_PATTERN = encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="180" height="180" viewBox="0 0 180 180">
  <g fill="none" stroke="#7ec8d8" stroke-width="1.1" opacity="0.55">
    <circle cx="90" cy="90" r="28"/>
    <circle cx="90" cy="90" r="48"/>
    <path d="M90 20c18 22 18 48 0 70C72 68 72 42 90 20z"/>
    <path d="M90 90c22-18 48-18 70 0-22 18-48 18-70 0z"/>
    <path d="M90 90c-18 22-18 48 0 70 18-22 18-48 0-70z"/>
    <path d="M90 90c-22-18-48-18-70 0 22 18 48 18 70 0z"/>
    <path d="M42 42c12-8 28-8 40 4-12 8-28 8-40-4z"/>
    <path d="M138 42c-12-8-28-8-40 4 12 8 28 8 40-4z"/>
    <path d="M42 138c12 8 28 8 40-4-12-8-28-8-40 4z"/>
    <path d="M138 138c-12 8-28 8-40-4 12-8 28-8 40 4z"/>
  </g>
</svg>
`);

export const PORTAL_THEMES = {
  talmuda: {
    logo: `${PUBLIC_URL}/mara-logo.png`,
    logoWidth: { xs: 140, sm: 180 },
    showTitle: true,
    pageBg: `
      radial-gradient(ellipse at 50% 0%, rgba(10,77,60,0.45) 0%, transparent 55%),
      radial-gradient(ellipse at 80% 100%, rgba(212,175,55,0.08) 0%, transparent 40%),
      linear-gradient(180deg, #050805 0%, #0a120e 40%, #050805 100%)
    `,
    htmlBg: '#050805',
    accent: '#e8c547',
    accentSoft: '#d4af37',
    accentMuted: 'rgba(212,175,55,0.35)',
    accentBorder: 'rgba(212,175,55,0.35)',
    accentBorderSoft: 'rgba(212,175,55,0.22)',
    accentHover: 'rgba(212,175,55,0.6)',
    surface: 'rgba(10,77,60,0.35)',
    surfaceSoft: 'rgba(10,77,60,0.25)',
    surfaceSelected: 'linear-gradient(180deg, rgba(10,77,60,0.55) 0%, rgba(0,0,0,0.28) 100%)',
    panelBg: 'linear-gradient(180deg, rgba(10,77,60,0.35) 0%, rgba(0,0,0,0.25) 100%)',
    listBg: '#0f2a1c',
    cardBorder: 'rgba(212,175,55,0.28)',
    cardBg: 'linear-gradient(180deg, rgba(8,28,20,0.92) 0%, rgba(5,12,8,0.95) 100%)',
    stepActiveBg: 'linear-gradient(135deg, #e8c547, #d4af37)',
    stepInactiveBorder: 'rgba(212,175,55,0.3)',
    dialogBorder: 'rgba(212,175,55,0.35)',
    dialogBg: 'linear-gradient(180deg, #0c1f18 0%, #08140f 100%)',
    progressColor: '#d4af37',
    ctaBg: 'linear-gradient(135deg, #e8c547 0%, #d4af37 55%, #b8941f 100%)',
    ctaColor: '#0a1f14',
    ctaDisabledBg: 'rgba(212,175,55,0.25)',
    ctaDisabledColor: 'rgba(10,31,20,0.5)',
    checkbox: '#e8c547',
    checkboxIdle: 'rgba(212,175,55,0.55)',
  },
  halacha: {
    logo: `${PUBLIC_URL}/mara-dehalcha-brand.png`,
    logoWidth: { xs: 220, sm: 280 },
    showTitle: false,
    pageBg: `
      radial-gradient(ellipse at 50% 12%, #0a6a82 0%, transparent 48%),
      radial-gradient(ellipse at 50% 100%, #012231 0%, transparent 55%),
      linear-gradient(180deg, #045870 0%, #033f54 38%, #022838 72%, #011820 100%)
    `,
    gridBg: `url("data:image/svg+xml,${HALACHA_PATTERN}")`,
    gridSize: '160px 160px',
    gridOpacity: 0.14,
    htmlBg: '#011820',
    accent: '#e5d1a0',
    accentSoft: '#c9b87a',
    accentMuted: 'rgba(201,184,122,0.35)',
    accentBorder: 'rgba(201,184,122,0.38)',
    accentBorderSoft: 'rgba(126,200,216,0.28)',
    accentHover: 'rgba(201,184,122,0.65)',
    surface: 'rgba(4,88,112,0.45)',
    surfaceSoft: 'rgba(3,63,84,0.4)',
    surfaceSelected: 'linear-gradient(180deg, rgba(8,120,148,0.45) 0%, rgba(1,32,48,0.45) 100%)',
    panelBg: 'linear-gradient(180deg, rgba(4,70,90,0.55) 0%, rgba(1,28,40,0.45) 100%)',
    listBg: '#033548',
    cardBorder: 'rgba(201,184,122,0.32)',
    cardBg: 'linear-gradient(180deg, rgba(3,52,70,0.92) 0%, rgba(1,28,40,0.95) 100%)',
    stepActiveBg: 'linear-gradient(135deg, #e5d1a0, #c9b87a)',
    stepInactiveBorder: 'rgba(201,184,122,0.35)',
    dialogBorder: 'rgba(201,184,122,0.4)',
    dialogBg: 'linear-gradient(180deg, #034a62 0%, #022a3a 100%)',
    progressColor: '#7ec8d8',
    ctaBg: 'linear-gradient(135deg, #e5d1a0 0%, #c9b87a 55%, #a8945e 100%)',
    ctaColor: '#0a1f28',
    ctaDisabledBg: 'rgba(201,184,122,0.25)',
    ctaDisabledColor: 'rgba(10,31,40,0.5)',
    checkbox: '#e5d1a0',
    checkboxIdle: 'rgba(126,200,216,0.55)',
  },
};

export function getPortalTheme(isHalacha) {
  return isHalacha ? PORTAL_THEMES.halacha : PORTAL_THEMES.talmuda;
}

export function fieldSxFromTheme(t) {
  return {
    '& .MuiOutlinedInput-root': {
      color: '#f5f0e6',
      background: 'rgba(255,255,255,0.04)',
      borderRadius: 2,
      '& fieldset': { borderColor: t.accentBorder },
      '&:hover fieldset': { borderColor: t.accentHover },
      '&.Mui-focused fieldset': { borderColor: t.accentSoft },
    },
    '& .MuiInputLabel-root': { color: 'rgba(245,240,230,0.7)' },
    '& .MuiInputLabel-root.Mui-focused': { color: t.accentSoft },
    '& .MuiSelect-icon': { color: t.accentSoft },
  };
}
